import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useAtom } from 'jotai';
import { NavLink } from 'react-router';

import CheckRequirements from '@/components/CheckRequirements';
import { submenuAtom } from '@/store/sidebar';

import useStyles from './SidebarSubmenuInline.styles';
import type {
  SidebarSubmenuButtonProps,
  SidebarSubmenuStateKey
} from './SidebarSubmenuInline.types';

function SidebarSubmenuInline(props: SidebarSubmenuButtonProps) {
  const { item } = props;

  const [isSubmenuExpanded] = useAtom(submenuAtom);
  const { classes } = useStyles();

  return (
    <Collapse
      in={isSubmenuExpanded[item.label as keyof SidebarSubmenuStateKey]}
      timeout="auto"
      unmountOnExit
    >
      <List disablePadding>
        {item.menu?.map((subItem) => (
          <CheckRequirements
            key={subItem.label}
            permissions={subItem.permissions}
          >
            <ListItem disablePadding key={subItem.label}>
              <NavLink
                aria-label={subItem.ariaLabel}
                className={classes.submenuInlineNavLink}
                to={subItem.pathTo}
              >
                <ListItemButton className={classes.submenuInlineButton}>
                  <ListItemText
                    className={classes.submenuInlineText}
                    primary={subItem.label}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          </CheckRequirements>
        ))}
      </List>
    </Collapse>
  );
}

export default SidebarSubmenuInline;
